import { create } from 'apisauce'
import Config from '../../config'

// Base
import { ApiResponse } from '../api/interfaces/ApiResponse'

// Requests
import {
  CreateLinkRequest
} from './interfaces/ApiRequest'

// Response
import {
  CreateLinkResponse
} from './interfaces/ApiResponse'

// Create our ApiSauce instance
const api = create({
  baseURL: Config.magicLinkAPI
})

// Configurations
export const setToken = (token: string) => api.setHeader('Authorization', `Bearer ${token}`)

export const createLink = async (data: CreateLinkRequest) => await api.post('api/store', data) as ApiResponse<CreateLinkResponse>
